<script>
export default {
    name: "NotFoundPage"
}
</script>

<template>
    <div class="not-found">
        <div class="not-found__logo">
            <a href="/">
                <svg width="200" height="20" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M159.163 0C153.082 0 148.719 4.47873 148.719 9.99677C148.719 15.5148 153.088 20 159.163 20C165.237 20 169.615 15.5213 169.615 9.99677C169.615 4.47224 165.264 0 159.163 0ZM159.163 16.4826C157.831 16.4903 156.527 16.116 155.417 15.407C154.306 14.6978 153.438 13.6861 152.923 12.4999C152.407 11.3137 152.269 10.0064 152.524 8.74383C152.779 7.48126 153.415 6.32021 154.355 5.40787C155.293 4.49554 156.491 3.87301 157.796 3.61921C159.101 3.36539 160.455 3.49173 161.686 3.98221C162.917 4.47268 163.969 5.3052 164.71 6.37422C165.45 7.44324 165.846 8.70065 165.846 9.98696C165.866 10.8422 165.708 11.6925 165.379 12.487C165.051 13.2814 164.56 14.0036 163.937 14.6103C163.313 15.217 162.567 15.6955 161.747 16.0173C160.927 16.339 160.048 16.4973 159.163 16.4826Z"
                          fill="#1D1D1B"/>
                    <path d="M80.6977 0C74.6133 0 70.25 4.47873 70.25 9.99677C70.25 15.5148 74.6199 20 80.6977 20C86.7753 20 91.1453 15.5213 91.1453 9.99677C91.1453 4.47224 86.7821 0 80.6977 0ZM80.6977 16.4826C79.3662 16.4903 78.0625 16.116 76.9515 15.407C75.8407 14.6978 74.9727 13.6861 74.4576 12.4999C73.9426 11.3137 73.8037 10.0064 74.0586 8.74383C74.3134 7.48126 74.9504 6.32021 75.8891 5.40787C76.8277 4.49554 78.0255 3.87301 79.3308 3.61921C80.6361 3.36539 81.9899 3.49173 83.2208 3.98221C84.4516 4.47268 85.5039 5.3052 86.2445 6.37422C86.9851 7.44324 87.3804 8.70065 87.3804 9.98696C87.4009 10.8422 87.2423 11.6925 86.9143 12.487C86.5862 13.2814 86.0954 14.0036 85.4713 14.6103C84.8471 15.217 84.1026 15.6955 83.2823 16.0173C82.462 16.339 81.5829 16.4973 80.6977 16.4826Z"
                          fill="#1D1D1B"/>
                    <path d="M66.1964 0.336014H63.8232C63.6535 0.336011 63.4907 0.400919 63.3704 0.516552C63.2501 0.632186 63.182 0.789137 63.1811 0.953096V13.7625L63.1072 13.8144L52.367 1.14796C51.9972 0.673786 51.7182 0.336014 51.1535 0.336014H49.0996C48.9302 0.336014 48.7678 0.401025 48.648 0.51675C48.5282 0.632476 48.4609 0.789435 48.4609 0.953096V19.0466C48.4609 19.2106 48.5281 19.3679 48.6478 19.4842C48.7675 19.6003 48.9299 19.6661 49.0996 19.667H51.4694C51.5537 19.667 51.637 19.6509 51.7147 19.6196C51.7924 19.5885 51.863 19.5427 51.9224 19.485C51.9816 19.4274 52.0286 19.3591 52.0605 19.2838C52.0924 19.2086 52.1086 19.128 52.1082 19.0466V6.23403L52.1855 6.18856L62.9424 18.855C63.3089 19.3259 63.5912 19.667 64.156 19.667H66.2099C66.3796 19.6661 66.542 19.6003 66.6617 19.4842C66.7814 19.3679 66.8486 19.2106 66.8486 19.0466V0.953096C66.8481 0.87108 66.8309 0.789963 66.7977 0.714436C66.7647 0.638908 66.7164 0.570471 66.6557 0.513083C66.5951 0.455696 66.5233 0.410494 66.4444 0.3801C66.3655 0.349706 66.2813 0.334725 66.1964 0.336014Z"
                          fill="#1D1D1B"/>
                    <path d="M141.704 12.2232C144.428 11.4146 146.41 9.206 146.387 6.45837C146.354 2.85979 143.385 0.303765 139.425 0.336244H130.899C130.815 0.335815 130.732 0.351463 130.654 0.382283C130.576 0.413102 130.505 0.458486 130.446 0.51583C130.386 0.573174 130.339 0.641344 130.306 0.716425C130.274 0.791505 130.257 0.872014 130.258 0.953325V19.0468C130.258 19.2114 130.325 19.3692 130.446 19.4855C130.566 19.6018 130.73 19.6672 130.899 19.6672H133.226C133.395 19.6663 133.558 19.6006 133.678 19.4844C133.797 19.3681 133.865 19.2108 133.865 19.0468V12.876H137.983L141.785 18.787C142.12 19.219 142.491 19.6574 142.985 19.6574H146.01C146.089 19.6677 146.17 19.6552 146.242 19.6218C146.313 19.5884 146.373 19.5354 146.413 19.4694C146.455 19.4033 146.474 19.3271 146.471 19.2503C146.467 19.1735 146.441 19.0994 146.393 19.0371L141.704 12.2232ZM133.865 3.61003H139.425C141.307 3.61003 142.605 4.72728 142.626 6.45837C142.626 8.34209 141.355 9.58925 139.472 9.60548H133.865V3.61003Z"
                          fill="#1D1D1B"/>
                    <path d="M120.791 0.956265C120.626 0.478838 120.404 0.335938 119.842 0.335938H116.982C116.42 0.335938 116.195 0.478838 116.03 0.956265L109.307 19.0465C109.166 19.3876 109.338 19.6669 109.69 19.6669H112.494C113.059 19.6669 113.278 19.5207 113.446 19.0401L114.85 14.9056H121.97L123.375 19.0401C123.544 19.5207 123.765 19.6669 124.327 19.6669H127.131C127.467 19.6669 127.655 19.3876 127.513 19.0465L120.791 0.956265ZM115.959 11.6286L118.346 4.58732H118.485L120.867 11.6286H115.959Z"
                          fill="#1D1D1B"/>
                    <path d="M184.633 16.312H176.723V0.953027C176.723 0.871717 176.706 0.791208 176.674 0.716127C176.641 0.641047 176.594 0.572876 176.534 0.515532C176.475 0.458188 176.404 0.4128 176.326 0.38198C176.249 0.35116 176.165 0.335518 176.081 0.335946H173.727C173.644 0.335518 173.56 0.35116 173.482 0.38198C173.404 0.4128 173.333 0.458188 173.274 0.515532C173.214 0.572876 173.167 0.641047 173.134 0.716127C173.102 0.791208 173.086 0.871717 173.086 0.953027V19.0466C173.086 19.2111 173.154 19.3689 173.274 19.4852C173.394 19.6016 173.558 19.6669 173.727 19.6669H184.647C184.817 19.6669 184.98 19.6016 185.101 19.4852C185.221 19.3689 185.289 19.2111 185.289 19.0466V16.9322C185.289 16.8497 185.272 16.7679 185.238 16.6919C185.205 16.6157 185.157 16.5468 185.096 16.4889C185.034 16.4312 184.963 16.3858 184.883 16.3554C184.803 16.325 184.718 16.3102 184.633 16.312Z"
                          fill="#1D1D1B"/>
                    <path d="M199.347 16.3119H191.427V0.953019C191.427 0.789358 191.361 0.632399 191.24 0.516674C191.12 0.400948 190.959 0.335938 190.789 0.335938H188.435C188.266 0.335938 188.104 0.400948 187.984 0.516674C187.864 0.632399 187.797 0.789358 187.797 0.953019V19.0465C187.796 19.1279 187.812 19.2085 187.844 19.2837C187.877 19.359 187.923 19.4273 187.983 19.485C188.042 19.5426 188.113 19.5884 188.19 19.6196C188.268 19.6508 188.351 19.6669 188.435 19.6669H199.358C199.528 19.6669 199.692 19.6015 199.812 19.4852C199.932 19.3689 200 19.211 200 19.0465V16.9322C200 16.85 199.983 16.7685 199.95 16.6926C199.917 16.6166 199.869 16.5478 199.808 16.4902C199.747 16.4324 199.676 16.3869 199.597 16.3563C199.517 16.3257 199.433 16.3106 199.347 16.3119Z"
                          fill="#1D1D1B"/>
                    <path d="M109.833 0.335938H107.029C106.468 0.335938 106.246 0.47884 106.077 0.959516L101.18 15.0583H101.049L96.1511 0.959516C95.9831 0.47884 95.7578 0.335938 95.1964 0.335938H92.3929C92.0567 0.335938 91.8651 0.611999 92.0097 0.953019L98.7328 19.0433C98.9009 19.524 99.1227 19.6669 99.6841 19.6669H102.541C103.106 19.6669 103.328 19.524 103.496 19.0433L110.22 0.953019C110.357 0.611999 110.189 0.335938 109.833 0.335938Z"
                          fill="#1D1D1B"/>
                    <path d="M40.0797 0.326928L33.6692 17.0402C33.3402 17.8977 32.7473 18.6373 31.9702 19.1597C31.1932 19.682 30.2693 19.9619 29.3227 19.9619C28.3761 19.9619 27.4522 19.682 26.6752 19.1597C25.8982 18.6373 25.3053 17.8977 24.9763 17.0402L19.46 2.66859C18.9977 1.59855 18.1931 0.699486 17.164 0.102828C18.2287 -0.0713691 19.3231 0.118787 20.2582 0.640518C21.1934 1.16225 21.9109 1.98287 22.2871 2.9609L25.736 11.9476L30.19 0.326928H32.8793L27.0739 15.4812L27.3462 16.186C27.3948 16.314 27.4568 16.4369 27.531 16.553L33.7599 0.313934H36.4727L29.9144 17.4039C30.2216 17.3127 30.5028 17.1542 30.736 16.9407C30.9693 16.7271 31.1483 16.4644 31.259 16.173L37.3434 0.313934L40.0797 0.326928ZM20.6197 17.3357L15.1068 2.9609C14.7777 2.10337 14.1848 1.36372 13.4078 0.841386C12.6308 0.319049 11.7069 0.0390625 10.7603 0.0390625C9.81371 0.0390625 8.8898 0.319049 8.11279 0.841386C7.33576 1.36372 6.74288 2.10337 6.41383 2.9609L0 19.6773H2.71277L8.80052 3.81832C8.91081 3.52663 9.08965 3.26364 9.32297 3.05005C9.5563 2.83647 9.83774 2.67809 10.1452 2.5874L3.59349 19.6773H6.30626L12.5352 3.43833C12.6082 3.55615 12.6701 3.68006 12.7201 3.80858L12.9924 4.51335L7.18698 19.6773H9.90647L14.3605 8.05671L17.8095 17.0402C18.184 18.0168 18.8988 18.837 19.8313 19.3598C20.7637 19.8826 21.8555 20.0753 22.919 19.9047C21.8883 19.3075 21.0825 18.4073 20.6197 17.3357ZM24.2065 17.3357L18.6936 2.9609C18.3181 1.98312 17.6012 1.16259 16.6666 0.640836C15.732 0.119077 14.6382 -0.0711981 13.574 0.102828C14.603 0.699486 15.4075 1.59855 15.8699 2.66859L21.3795 17.0402C21.755 18.0186 22.4723 18.8396 23.4077 19.3613C24.343 19.8832 25.4376 20.073 26.5024 19.8982C25.4727 19.3038 24.6677 18.4055 24.2065 17.3357Z"
                          fill="#EE463B"/>
                </svg>
            </a>
        </div>
        <div class="not-found__content">
            <h1 class="not-found__title">
                Такой страницы нет :(
            </h1>
            <span class="not-found__text">
        Зато у нас много разной упаковки
      </span>
            <img src="/upload/404-icon.png" alt="" class="not-found__icon">
            <a href="/" class="not-found__link">
                <span>Вернуться на главную</span>
                <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.0125 2.25H0V3.75H15.0125V6L20 3L15.0125 0V2.25Z" fill="#EE463B"/>
                </svg>
            </a>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import "../../theme/variable";

.not-found {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFF;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 767px) {
    padding: 20px 0;
  }

  &__logo {
    width: 200px;
    height: 20px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  }

  &__title {
    color: #1D1D1B;
    text-align: center;
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 117.647%;
    letter-spacing: -0.68px;
    margin-bottom: 10px;
    margin-top: 0 !important;

    @media (max-width: 767px) {
      font-size: 24px;
    }
  }

  &__text {
    display: block;
    color: #1D1D1B;
    text-align: center;
    font-family: 'RobotoRegular', sans-serif;
    font-size: 15px;
    line-height: 120%;
    margin-bottom: 20px;
  }

  &__icon {
    width: 310px;
    height: auto;
    margin-bottom: 20px;
  }

  &__link {
    background: #fff;
    border-radius: 28px;
    border: 1px solid #EE463B;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 10px;

    & > svg {
      transition: all .3s ease;
    }

    &:hover {
      & > svg {
        transform: translateX(10px);
      }
    }
  }
}
</style>